import React, { FC } from 'react';
import styled from 'styled-components';
import { CustomBlockContent } from './CustomBlockContent';

interface ArticleWithButtonProps {
  title: string;
  article: any;
  toggle?: () => void;
  scrollToRef?: any;
  buttonText: string;
  open: boolean;
}

export const ArticleWithButton: FC<ArticleWithButtonProps> = ({
  title,
  article,
  toggle,
  scrollToRef,
  buttonText,
  open,
}) => {
  return (
    <StyledArticleWithButton ref={scrollToRef}>
      <div className="width-container">
        <h2> {title} </h2>
        <div className="article-container">
          <article>
            <CustomBlockContent blocks={article} />
          </article>
        </div>
        <div className="button-container">
          {/* Might be used again...
          <button
            onClick={toggle}
            className={open ? 'black-transparent' : 'red'}
          >
            {buttonText}
          </button> */}
        </div>
      </div>
    </StyledArticleWithButton>
  );
};

const StyledArticleWithButton = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 65px;
  margin-top: -65px;
  .width-container {
    padding: 0 35px;
  }

  h2 {
    text-align: center;
    margin: 40px 0 0 0;
    width: 100%;
  }

  .button-container {
    margin-bottom: 25px;
    min-width: 300px;
    @media (max-width: 868px) {
      min-width: 185px;
    }
    @media (max-width: 500px) {
      min-width: 80%;
    }
  }

  .article-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 25px 0;
    text-align: justify;
    article {
      color: var(--black);
      line-height: 1.2em;
      column-count: 2;
      column-gap: 35px;
      font-size: 1em;
      column-width: 400px;
      padding: 35px;
      word-wrap: break-word;
      @media (max-width: 868px) {
        font-size: 0.8em;
        column-count: 1;
        padding: 0;
      }
    }
  }
`;
